/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ShadowDecisionOutcome = {
    Admit: 'ADMIT',
    Reject: 'REJECT',
    NeedsReview: 'NEEDS_REVIEW',
} as const;
export type ShadowDecisionOutcome = typeof ShadowDecisionOutcome[keyof typeof ShadowDecisionOutcome];


export function instanceOfShadowDecisionOutcome(value: any): boolean {
    for (const key in ShadowDecisionOutcome) {
        if (Object.prototype.hasOwnProperty.call(ShadowDecisionOutcome, key)) {
            if (ShadowDecisionOutcome[key as keyof typeof ShadowDecisionOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ShadowDecisionOutcomeFromJSON(json: any): ShadowDecisionOutcome {
    return ShadowDecisionOutcomeFromJSONTyped(json, false);
}

export function ShadowDecisionOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowDecisionOutcome {
    return json as ShadowDecisionOutcome;
}

export function ShadowDecisionOutcomeToJSON(value?: ShadowDecisionOutcome | null): any {
    return value as any;
}

export function ShadowDecisionOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): ShadowDecisionOutcome {
    return value as ShadowDecisionOutcome;
}

